import { gql, useMutation } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedMutation } from '@/lib/apollo/types'

const removeLandlordRefereeMutation = gql`
  mutation removeLandlordReferee(
    $customerId: String!
    $subjectId: String!
    $userId: String!
    $reason: String!
  ) {
    removeLandlordReferee(
      customerId: $customerId
      subjectId: $subjectId
      userId: $userId
      reason: $reason
    )
  }
`

export type MutationVars = {
  customerId: string
  subjectId: string
  userId: string
  reason: string
}

export type RemoveLandlordRefereeData = {
  removeLandlordReferee: string | unknown
}

export const useRemoveLandlordRefereeMutation: WrappedMutation<
  RemoveLandlordRefereeData,
  MutationVars
> = () =>
  useMutation<RemoveLandlordRefereeData, MutationVars>(removeLandlordRefereeMutation, {
    client: agentClient,
  })
